import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { openCancelReturnLabelModal } from '../../../../../../../store/returns/returns.actions';
import { RETURN_ACTION_VOID_LABEL_CLICKED } from '../../../../../../../constants/analytics-events';
import { Segment } from '../../../../../../../services/analytics-services/segment';

import messages from '../../../../../rate-card/read-only/label-actions/messages';

const VoidReturnLabel = ({ returnFulfillmentId, isDisabled = false }) => {
  const dispatch = useDispatch();

  const openVoidLabelModal = useCallback(() => {
    Segment.trackEvent(RETURN_ACTION_VOID_LABEL_CLICKED, {
      type: RETURN_ACTION_VOID_LABEL_CLICKED,
      enhanced: false,
      fulfillmentId: returnFulfillmentId,
    });
    dispatch(openCancelReturnLabelModal([returnFulfillmentId], true));
  }, [dispatch, returnFulfillmentId]);

  return (
    <DropdownMenuItem disabled={isDisabled} onClick={openVoidLabelModal}>
      <FormattedMessage {...messages.voidLabel} />
    </DropdownMenuItem>
  );
};

export { VoidReturnLabel };

VoidReturnLabel.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
};
